<template>
  <v-container fluid class="px-0 py-0">
    <v-card>
      <v-card-text>
        <div class="total-org">
          共<b>{{ totalCount }}</b>家企业
        </div>
        <p class="sys-alert" style="font-size: 12px;">
          该数据仅为当前系统中的企业数据，未明确标记类型的企业都会归类到<b>未标记</b>。
        </p>
        <v-layout row wrap grid-list-md>
          <v-flex xs12 sm8 md9>
            <v-layout row wrap>
              <v-flex xm12 sm4 md2 v-for="(o, idx) in tagCount" :key="o.n">
                <v-card class="panel panel-1" :color="colors[idx + 1]" dark
                  :class="{ active: idx == selIdx, hit: orgCrud != null }" @click="onTag(idx)">
                  <v-card-text :title="o.n">
                    <div>
                      <v-icon :size="24" class="left-icon">domain</v-icon>
                      <label>{{ o.c }}</label>
                    </div>
                    <div class="label">
                      <em>{{ o.n }}</em>
                    </div>
                    <div v-show="idx == selIdx" class="tag-icon">
                      <v-icon :size="16" color="white">expand_more</v-icon>
                    </div>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
            <v-divider />
            <div v-if="chartOpt">
              <div style="text-align: right;">
                <span style="font-size:12px;cursor: pointer" @click="dataView = !dataView">{{
            dataView ? '图表视图' : '数据视图' }}</span>
              </div>
              <keep-alive>
                <v-data-table :headers="tableHeader" :items="tableData" v-if="dataView" class="elevation-1"
                  :rows-per-page-items="[50, 100, { text: '全部', value: -1 }]">
                  <template v-slot:items="props">
                    <td v-for="header in tableHeader" :key="header.text">{{ props.item[header.value] }}</td>
                  </template>
                </v-data-table>
                <v-chart v-else class="v-chart" autoresize :option="chartOpt" :style="{
            height: chartOpt.yAxis[0].data.length * 60 + 60 + 'px',
          }" @click="onBarClick" />
              </keep-alive>
            </div>
            <div v-if="orgCrud" class="org-list">
              <span class="alert-msg">
                <v-icon :size="16" color="orange">info</v-icon>可通过企业后面图标按钮做更多操作
              </span>
              <crud :cfg="orgCrud" :timestamp="orgCrudTs" />
            </div>
          </v-flex>
          <v-flex xs12 sm4 md3>
            <div class="grid-right">
              <v-chart class="v-chart-r" v-if="tagCountChart" :option="tagCountChart" autoresize />
              <v-chart class="v-chart-r" v-if="locCountChart" :option="locCountChart" autoresize />
            </div>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { BarChart, PieChart } from "echarts/charts";

import {
  TitleComponent,
  TooltipComponent,
  ToolboxComponent,
  GridComponent,
} from "echarts/components";

import VChart from "vue-echarts";

import { Crud } from "javaee-fre";

use([
  CanvasRenderer,
  BarChart,
  PieChart,
  TitleComponent,
  TooltipComponent,
  ToolboxComponent,
  GridComponent,
]);

export default {
  name: "mo-org-chart",
  props: { loc: String },
  components: {
    "v-chart": VChart,
    crud: Crud,
  },
  data() {
    return {
      chartOpt: null,
      totalCount: 0,
      tagCount: [],
      tagCountChart: null,
      locs: [],
      orgCrud: null,
      orgCrudTs: Date.now(),
      selIdx: -1,
      currentLoc: null,
      locCountChart: null,
      colors: this.$colors,
      dataView: false
    };
  },
  computed: {
    tableHeader() {
      let series = this.chartOpt.series, headers = [{ text: '地区', value: 'region' }];
      for (let s of series) {
        headers.push({ text: s.name, value: s.name });
      }
      return headers;
    },
    tableData(){
      let categories = this.chartOpt.yAxis[0].data, series = this.chartOpt.series, data = [], i = 0;
      for (let c of categories) {
        let row = { region: c };
        for (let s of series) {
          let d = s.data;
          row[s.name] = d[i];
        }
        data.push(row);
        i++;
      }
      return data;
    }
  },
  methods: {
    buildOrgCrud(idx) {
      let self = this,
        n = "家企业",
        params = { _loc: self.currentLoc };
      if (idx === undefined) {
        idx = -1;
      }
      if (idx >= 0) {
        let tag = self.tagCount[idx];
        if (tag) {
          params._tag = tag.id;
          n = `家${tag.n}企业`;
        }
      }

      self.orgCrud = {
        url: "/home/my/mo/org",
        params: params,
        refreshable: false,
        countEndding: n,
        listItemActions: [
          {
            label: "设为重点关注",
            confirm: "确认设为重点关注企业吗？",
            icon: "visibility",
            func(cfg) {
              let crud = this;
              crud.$axios
                .get(`/home/my/mo/org/update/focus/${cfg.item.id}/true`)
                .then(() => {
                  crud.refresh();
                });
            },
          },
          {
            label: "取消重点关注",
            confirm: "确认重点关注企业中移除吗？",
            icon: "visibility_off",
            func(cfg) {
              let crud = this;
              crud.$axios
                .get(`/home/my/mo/org/update/focus/${cfg.item.id}/false`)
                .then(() => {
                  crud.refresh();
                });
            },
          },
          {
            label: "学员",
            icon: "person",
            func(cfg) {
              self.$emit("org_stu_click", cfg.item);
            },
          },
          {
            label: "培训计划",
            icon: "schedule",
            func(cfg) {
              self.$emit("org_clazz_click", cfg.item);
            },
          },
        ],
        listItemFilter(i, acts) {
          if (i.focusOn) {
            this.delAction(acts, "icon", "visibility");
            i._rowClazz = "focus-on-row";
          } else {
            this.delAction(acts, "icon", "visibility_off");
          }
          return acts;
        },
      };

      self.orgCrudTs = Date.now();
    },
    onTag(idx) {
      let self = this,
        selIdx = self.selIdx;
      if (!self.orgCrud) {
        return; //对没有机构过滤的直接返回
      }
      if (idx == selIdx) {
        self.selIdx = -1;
      } else {
        self.selIdx = idx;
      }
      self.buildOrgCrud(self.selIdx);
    },
    onBarClick(b) {
      let self = this,
        loc = self.locs[b.dataIndex];
      self.$emit("bar_click", loc);
    },
    init() {
      let self = this,
        url = "/home/my/mo/summary/org";
      if (self.loc) {
        url = url + "?_loc=" + self.loc;
      }
      self.$axios.get(url).then((r) => {
        if (r.data.status != "ok") {
          return;
        }
        let m = r.data.message,
          leaf = !r.data.regions || r.data.regions.length == 0,
          tagHash = {};

        if (r.data.tags) {
          for (let tag of r.data.tags) {
            tagHash[tag.id] = tag;
          }
        }

        let reHash = {};
        if (!leaf) {
          for (let re of r.data.regions) {
            reHash[re.id] = re;
          }
        }

        //生成填充数据
        let tcHash = {},
          categories = [],
          sHash = {},
          len = Object.keys(m).length,
          tSerie = [],
          totalCount = 0,
          locs = [];

        for (let k in m) {
          let rd = m[k],
            ts = 0;
          for (let tk in rd) {
            let c = rd[tk][0],
              tc = (tcHash[tk] || 0) + c,
              s = sHash[tk];
            ts += c;
            totalCount += c;
            tcHash[tk] = tc;

            if (!s) {
              s = [];
              for (let i = 0; i < len; i++) {
                s.push(0);
              }
              sHash[tk] = s;
            }
            if (!leaf) {
              s[categories.length] += c;
            }
          }
          if (!leaf && reHash[k]) {
            categories.push(reHash[k].name);
            locs.push({ n: reHash[k].name, id: k });
          }

          tSerie.push(ts);
        }
        self.locs = locs;

        //生成图表数据
        let series = [],
          idx = 1,
          tagCount = [],
          tagCountChart = {
            title: { subtext: "各类型企业占比" },
            tooltip: { show: true },
            series: [
              {
                type: "pie",
                label: { show: false },
                data: [],
              },
            ],
          };
        for (let s in sHash) {
          let n = s == 0 ? "未标记" : tagHash[s].name,
            color = self.colors[idx++],
            c = tcHash[s];
          tagCount.push({ c: c, n: n, id: s });
          series.push({
            name: n,
            type: "bar",
            stack: "total",
            barWidth: 20,
            data: sHash[s],
            color: color,
          });
          tagCountChart.series[0].data.push({
            value: c,
            name: `${n}(${((c * 100) / totalCount).toFixed(1)}%)`,
            itemStyle: { color: color },
          });
        }
        self.tagCountChart = tagCountChart;
        self.totalCount = totalCount;
        self.tagCount = tagCount;
        if (leaf) {
          if (len != 1) {
            return;
          }
          //列出下面的机构及统计信息
          self.currentLoc = Object.keys(m)[0];
          self.buildOrgCrud();
        } else {
          let locCountChart = {
            title: { subtext: "各地区企业占比" },
            tooltip: { show: true },
            series: [
              {
                type: "pie",
                label: { show: false },
                data: [],
              },
            ],
          };
          let idx = 0;
          for (let loc of categories) {
            let v = tSerie[idx++];
            locCountChart.series[0].data.push({
              name: `${loc}(${((v * 100) / totalCount).toFixed(1)}%)`,
              value: v,
            });
          }
          self.locCountChart = locCountChart;
          series.push({
            name: "总计",
            type: "bar",
            barWidth: 5,
            data: tSerie,
            label: { show: true, position: "right" },
            color: self.colors[0],
            itemStyle: { borderRadius: [0, 10, 10, 0] }
          });
          let cfg = {
            title: {
              subtext:
                "没有显示的地区表示没有数据  | {tip|下面图表点击可以切换到具体的地区数据}",
              subtextStyle: {
                rich: {
                  tip: { color: "orange", fontSize: "10px" },
                },
              },
            },
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "shadow",
              },
            },
            grid: {
              left: "3%",
              right: "4%",
              bottom: "3%",
              containLabel: true,
            },
            yAxis: [
              {
                type: "category",
                data: categories,
              },
            ],
            xAxis: [
              {
                type: "value",
              },
            ],
            series: series,
          };

          self.chartOpt = cfg;
        }
      });
    },
  },
  created() {
    this.init();
  },
};
</script>
<style scoped>
.v-chart {
  width: 100%;
}

.v-chart-r {
  height: 250px;
}

.v-divider {
  margin-top: 16px;
}

.panel {
  margin: 8px;
}

.panel-1 {
  min-height: 70px;
}

.panel-1 .left-icon {
  float: left;
}

.panel-1 label {
  font-weight: bold;
  font-size: 16px;
  clear: left;
}

.panel-1 .label {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.total-org b {
  color: red;
  font-size: 18px;
  padding: 4px;
}

.org-list {
  margin-top: 16px;
}

.focus-on-row td {
  color: red !important;
}

.alert-msg {
  color: orange;
  float: right;
  font-size: 10px;
}

.v-card .hit {
  cursor: pointer;
}

.v-card .tag-icon {
  text-align: center;
}

.grid-right {
  background-color: #f8f8f8;
  border-radius: 8px;
  padding: 8px;
  margin: 8px;
}
</style>